import React from 'react';
import { Box } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { sizes } from 'src/styles/Media.styled';
import { StyledTextDiv } from 'src/pages/reportUsage/utils/reportUsage.styled';
import { isIpad } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
const useStyles = makeStyles(() => ({
    paper: {
        padding: '13px 17px 13px 15px',
    },
}));

const HeaderTemplate = () => {
    const classes = useStyles();
    const winWidth = window.innerWidth;
    const isMobileView = winWidth <= sizes.mobileDevice;
    const isDesktopView = winWidth >= sizes.mediumDevice;
    const iPad = isIpad();
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <Box
                className={classes.paper}
                my={1}
                bgcolor={'#ffffff'}
                style={{
                    height: '48px',
                    borderRadius: '6px 6px 0px 0px',
                    background: '#FFFFFF 0% 0% no-repeat padding-box',
                    boxShadow: '0px 3px 2px #00000029',
                    border: '1px solid #DCDCDC',
                    opacity: '0.62',
                }}
            >
                <Grid
                    container
                    item
                    alignItems={'flex-start'}
                    justifyContent={!iPad && 'space-between'}
                >
                    {!isMobileView && !iPad && (
                        <Grid item lg={4} md={4} sm={6}>
                            <StyledTextDiv opacity={0.7}>
                                {t('common.itemDetailsText')}
                            </StyledTextDiv>
                        </Grid>
                    )}
                    {iPad && !isMobileView && <Grid sm={5}></Grid>}

                    <Grid item lg={8} md={8} sm={7} xs={12}>
                        <TitleBox>
                            {isDesktopView && (
                                <TitleContainer
                                    width={'100px'}
                                    justifyContent={'center'}
                                >
                                    <StyledTextDiv opacity={0.7} width={'75px'}>
                                        {t('consignmentBilling.priceOverride.priceOverrideTable.qty')}
                                    </StyledTextDiv>
                                </TitleContainer>
                            )}

                            <TitleContainer
                                width={'115px'}
                                justifyContent={
                                    isMobileView ? 'flex-start' : 'flex-end'
                                }
                            >
                                <StyledTextDiv
                                    opacity={0.7}
                                    textAlign={
                                        !isDesktopView && !isMobileView && 'end'
                                    }
                                >
                                    {t('consignmentBilling.priceOverride.priceOverrideTable.adjustedPrice')}
                                </StyledTextDiv>
                            </TitleContainer>

                            {isDesktopView && (
                                <TitleContainer
                                    width={'160px'}
                                    justifyContent={'center'}
                                >
                                    <StyledTextDiv opacity={0.7}>
                                        {t('reportUsage.record.priceOverride.PriceOverrideTable.discount')}
                                    </StyledTextDiv>
                                </TitleContainer>
                            )}

                            <TitleContainer
                                width={'100px'}
                                justifyContent={'flex-end'}
                            >
                                <StyledTextDiv
                                    opacity={0.7}
                                    textAlign={!isDesktopView && 'end'}
                                >
                                    {t('reportUsage.record.priceOverride.PriceOverrideTable.unitPrice')}
                                </StyledTextDiv>
                            </TitleContainer>
                            <TitleContainer
                                width={'100px'}
                                justifyContent={'flex-end'}
                            >
                                <StyledTextDiv
                                    opacity={0.7}
                                    textAlign={!isDesktopView && 'end'}
                                >
                                    {t('reportUsage.record.priceOverride.PriceOverrideTable.extPrice')}
                                </StyledTextDiv>
                            </TitleContainer>
                        </TitleBox>
                    </Grid>
                </Grid>
            </Box>
        </React.Fragment>
    );
};

export default HeaderTemplate;

export const TitleContainer = styled.div`
    display: flex;
    justify-content: ${({ justifyContent }) => justifyContent};
    width: ${({ width }) => width};
`;

export const TitleBox = styled.div`
    display: flex;
    justify-content: space-between;
`;
